module.exports = __webpack_public_path__ + "media/images/icons/star_icon-89bc6a9f7e8d9d8d9170fd91af946a70.svg";